module.exports = __webpack_public_path__ + "static/media/contextualMenu.7072403e.svg";